export default __webpack_public_path__ + "static/media/gymidle.156f9aff.png";